import { FunctionComponent, ReactNode, useEffect, useRef } from "react";

interface Props {
  onLoad: (isLazyloaded: true) => void;
  className?: string;
  children: ReactNode;
}

const LazyloadWrapper: FunctionComponent<Props> = ({
  children,
  onLoad,
  className,
}) => {
  const elRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      if (!entries.length) return;
      const entry = entries[0];

      if (entry.isIntersecting) {
        onLoad(true);
        observer.unobserve(entry.target);
      }
    });

    if (elRef.current) {
      observer.observe(elRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={elRef} className={className}>
      {children}
    </div>
  );
};

export default LazyloadWrapper;
